import { useAuthContext } from '@features/auth';

export const useAuth = () => {
  const { isAuthorized, isLoading, user } = useAuthContext();

  return {
    isLoggedIn: isAuthorized,
    isLoading,
    accessToken: undefined,
    userId: user?.id,
  };
};
